/**
 * Hook para buscar etapas (stages) de uma instância de execução
 */
import { useQuery } from '@tanstack/react-query';
import { getInstanceStages } from '../services/instanceDetailService';
import { executionKeys } from '../keys';

export function useInstanceStages(organizationId?: string, instanceId?: string) {
  const query = useQuery({
    queryKey: [...executionKeys.detail(organizationId ?? '', instanceId ?? ''), 'stages'],
    enabled: Boolean(organizationId && instanceId),
    queryFn: () => getInstanceStages(organizationId!, instanceId!),
    staleTime: 15_000,
  });

  return {
    stages: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
